import React, { useState, useEffect, useRef } from 'react';
import { useMediaQuery, Grid, Hidden } from '@material-ui/core';
import { Submenu, SubmenuItem, TabelaCalendario } from '../../components';

import { etfService, documentsService } from '../../service';

import {
	getDateTimeString,
	smoothScroll,
	formatCurrencyToBRL,
	formatValueToBRL,
} from '../../utils/functions';

import {
	Container,
	Title,
	BoxCestaIntegralizacao,
	BoxCestaResgate,
	BoxCarteira,
	BoxEmprestimo,
	BoxComposicao,
	ContentCestaIntegralizacao,
	ContentCestaResgate,
	ContentCarteira,
	ContentEmprestimo,
	ContentComposicao,
	BlockCestaIntegralizacao,
	BlockCarteira,
	BlockCestaResgate,
	BlockComposicao,
	Tabela,
	ImagemCarteira
} from './styles';

const getCesta = list => {
	return list.map(item => [
		item.Codigo,
		item.DsAtivo,
		formatValueToBRL(item.Quantidade),
		formatCurrencyToBRL(item.ValorAbertura),
		formatCurrencyToBRL(item.PaticipacaoTotalCesta),
	]);
};

const getCarteira = list => {
	return list.map(item => [
		item.Categoria,
		formatCurrencyToBRL(item.Financeiro),
		formatCurrencyToBRL(item.Peso),
	]);
};

const getEmprestimo = list => {
	return list.map(item => [
		item.Codigo,
		item.Papel,
		formatValueToBRL(item.Quantidade),
		formatCurrencyToBRL(item.ValorUnitario),
		formatCurrencyToBRL(item.ValorTotal),
		formatCurrencyToBRL(item.sPL),
	]);
};

const getComposicao = list => {
	return list.map(item => [
		item.Codigo,
		item.Papel,
		formatValueToBRL(item.Quantidade),
		formatCurrencyToBRL(item.sPL),
	]);
};

export default () => {
	const matches = useMediaQuery('(max-width:768px)');

	const [integralizacaoData, setIntegralizacaoData] = useState(null);
	const [resgateData, setResgateData] = useState(null);
	const [carteiraData, setCarteiraData] = useState(null);
	const [emprestimoData, setEmprestimoData] = useState(null);
	const [composicaoData, setComposicaoData] = useState(null);


	const [cestaIntegralizacaoDate, setCestaIntegralizacaoDate] = useState(null);
	const [cestaResgateDate, setCestaResgateDate] = useState(null);
	const [carteiraDate, setCarteiraDate] = useState(null);
	const [emprestimoDate, setEmprestimoDate] = useState(null);


	const integralizacaoRef = useRef(null);
	const resgateRef = useRef(null);
	const carteiraRef = useRef(null);
	const emprestimoRef = useRef(null);
	const composicaoRef = useRef(null);


	const getDateAtualizacaoComposicao = async () => {
		try {
			const response = await etfService.DatesAtualizacaoComposicao();
			const responseData = await response.data;

			setCestaIntegralizacaoDate(responseData.ObjJsonResultado.CestaIntegralizacao);
			setCestaResgateDate(responseData.ObjJsonResultado.CestaResgate);
			setCarteiraDate(responseData.ObjJsonResultado.Carteira);
			setEmprestimoDate(responseData.ObjJsonResultado.Emprestimo);

		} catch (err) {
			setCestaIntegralizacaoDate("");
			setCestaResgateDate("");
			setCarteiraDate("");
			setEmprestimoDate("");
			console.error(
				'Ocorreu um erro ao chamar a API de Composição/Cesta Integralizacao - Erro: ',
				err,
			);
		}
	};

	const getDataCestaIntegralizacao = async () => {
		try {
			const response = await etfService.CestaIntegralizacao();
			const responseData = await response.data;

			const integralizacao = getCesta(
				responseData.ObjJsonResultado.CestaIntegracao,
			);

			setIntegralizacaoData(integralizacao);
		} catch (err) {
			setIntegralizacaoData([]);
			console.error(
				'Ocorreu um erro ao chamar a API de Composição/Cesta Integralizacao - Erro: ',
				err,
			);
		}
	};

	const getDataCestaResgate = async () => {
		try {
			const response = await etfService.CestaResgate();
			const responseData = await response.data;

			const resgate = getCesta(responseData.ObjJsonResultado.CestaResgate);

			setResgateData(resgate);
		} catch (err) {
			setResgateData([]);
			console.error(
				'Ocorreu um erro ao chamar a API de Composição/Cesta Resgate - Erro: ',
				err,
			);
		}
	};

	const getDataCarteira = async () => {
		try {
			const response = await etfService.Carteira();
			const responseData = await response.data;

			const carteira = getCarteira(responseData.ObjJsonResultado.Carteira);

			setCarteiraData(carteira);		
		} catch (err) {
			setCarteiraData([]);
			console.error(
				'Ocorreu um erro ao chamar a API de Composição/Carteira - Erro: ',
				err,
			);
		}
	};

	const getDataEmprestimo = async () => {
		try {
			const response = await etfService.Emprestimo();
			const responseData = await response.data;

			const emprestimo = getEmprestimo(
				responseData.ObjJsonResultado.Emprestimo,
			);

			setEmprestimoData(emprestimo);	
		} catch (err) {
			setEmprestimoData([]);
			console.error(
				'Ocorreu um erro ao chamar a API de Composição/Emprestimo - Erro: ',
				err,
			);
		}
	};

	const getDataComposicaoIndice = async () => {
		try {
			const response = await etfService.Indice();
			const responseData = await response.data;
			
			const composicao = getComposicao(responseData.ObjJsonResultado.Indice);

			setComposicaoData(composicao);
				
		} catch (err) {
			setComposicaoData([]);
			console.error(
				'Ocorreu um erro ao chamar a API de Composição/Composicao Indice - Erro: ',
				err,
			);
		}
	};

	useEffect(() => {
		const getData = async () => {
			await getDateAtualizacaoComposicao();
			await getDataCestaIntegralizacao();
			await getDataCestaResgate();
			await getDataCarteira();
			await getDataEmprestimo();
			await getDataComposicaoIndice();
		};

		getData();
	}, []);

	const handleDownloadClick = async path => {
		try {
			const response = await documentsService.downloadComposicao(path);
			const responseData = await response.data;

			const downloadUrl = window.URL.createObjectURL(
				new Blob([responseData], {
					type: 'application/vnd.ms-excel.sheet.macroEnabled.12',
				}),
			);

			const filename = path.replace('Download', '');
			const link = document.createElement('a');

			link.href = downloadUrl;
			link.download = `${filename}_${getDateTimeString()}.xlsx`;
			document.body.appendChild(link);

			link.click();

			link.remove();
		} catch (err) {
			console.error('An occurred while downloading file: ', err);
		}
	};

	return (
		<Container>
			<Hidden mdUp>
				<Title>Composição</Title>
			</Hidden>
			<Hidden smDown>
				<Submenu>
					<SubmenuItem
						onClick={() => smoothScroll('#integralizacao')}
						label="Cesta de integralização"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#resgate')}
						label="Cesta de resgate"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#carteira')}
						label="Carteira"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#emprestimo')}
						label="Empréstimo"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#composicao')}
						label="Composição do índice"
					/>
				</Submenu>
			</Hidden>

			<BoxCestaIntegralizacao>
				<ContentCestaIntegralizacao ref={integralizacaoRef}>
					<Grid container>
						<Grid
							item
							lg={2}
							md={2}
							sm={12}
							xs={12}
							className="IntegralizacaoImagem"
						>
							<img
								src="images/icone-cesta-de-integralizacao.svg"
								alt="Ícone cesta de integralização"
							/>
						</Grid>
						<Grid
							item
							lg={10}
							md={10}
							sm={12}
							xs={12}
							className="IntegralizacaoGrid"
						>
							<h2 id="integralizacao">Cesta de integralização</h2>
							<BlockCestaIntegralizacao>
								<Tabela>
									<TabelaCalendario
										variant="white"
										reference="int"
										headers={[
											'Ticker',
											'Ativo',
											'Quantidade',
											'Preço de Abertura (R$)',
											'Peso (%)',
										]}
										data={integralizacaoData}
										buttonText="Cesta completa"
										hideFilterCalendar={true}
										onDownloadClick={() => handleDownloadClick('DownloadCesta')}
										rowsPerPageInit={10}
										hidePagination={false}
										textColorPagination="darkblue"
										backgroudColorPagination="darkblue"
										showUpdateDate={true}
										updateDate={cestaIntegralizacaoDate}
									/>
							
								</Tabela>
							</BlockCestaIntegralizacao>
							
						</Grid>
					</Grid>
				</ContentCestaIntegralizacao>
			</BoxCestaIntegralizacao>

			<BoxCestaResgate>
				<ContentCestaResgate ref={resgateRef}>
					<BlockCestaResgate>
						<h2 id="resgate">Cesta de resgate</h2>
						<Tabela>
							<TabelaCalendario
								variant="light-blue"
								reference="res"
								headers={[
									'Ticker',
									'Ativo',
									'Quantidade',
									'Preço de Abertura (R$)',
									'Peso (%)',
								]}
								data={resgateData}
								buttonText="Cesta completa"
								hideFilterCalendar={true}
								onDownloadClick={() =>
									handleDownloadClick('DownloadCestaResgate')
								}
								rowsPerPageInit={10}
								hidePagination={false}
								textColorPagination="white"
								backgroudColorPagination="darkblue"
								showUpdateDate={true}
								updateDate={cestaResgateDate}
							/>
						</Tabela>
					</BlockCestaResgate>
				</ContentCestaResgate>
			</BoxCestaResgate>

			<BoxCarteira>
				<ContentCarteira ref={carteiraRef}>
					<Grid container>
						<Grid item lg={5} md={5} sm={12} xs={12} className="CarteiraImagem">
								<ImagemCarteira/>
						</Grid>
						<Grid item lg={7} md={7} sm={12} xs={12} className="CarteiraGrid">
							<h2 id="carteira">Carteira</h2>
							<BlockCarteira>
								<Tabela>
									<TabelaCalendario
										variant="white"
										reference="car"
										headers={['Categoria', 'Financeiro (R$)', 'Peso (%)']}
										data={carteiraData}
										buttonText="Carteira completa"
										hideFilterCalendar={true}
										negritoLastFlag={1}
										hidePagination={true}
										onDownloadClick={() =>
											handleDownloadClick('DownloadCarteira')
										}
										showUpdateDate={true}
										updateDate={carteiraDate}
										backgroudColorPagination="darkblue"
									/>
								</Tabela>
							</BlockCarteira>
						</Grid>
					</Grid>
				</ContentCarteira>
			</BoxCarteira>

			<BoxEmprestimo>
				<ContentEmprestimo ref={emprestimoRef}>
					<h2 id="emprestimo">Empréstimo</h2>
					<Tabela>
						<TabelaCalendario
							variant={matches ? 'light-blue' : 'white'}
							reference="emp"
							headers={[
								'Ticker',
								'Ativo',
								'Quantidade',
								'Preço (R$)',
								'Financeiro total (R$)',
								'% Patrimônio Líquido',
							]}
							data={emprestimoData}
							buttonText="Empréstimo completo"
							hideFilterCalendar={true}
							onDownloadClick={() => handleDownloadClick('DownloadEmprestimo')}
							rowsPerPageInit={7}
							hidePagination={false}
							textColorPagination="darkblue"
							backgroudColorPagination="darkblue"
							showUpdateDate={true}
							updateDate={emprestimoDate}
						/>
					</Tabela>
				</ContentEmprestimo>
			</BoxEmprestimo>

			<BoxComposicao>
				<ContentComposicao ref={composicaoRef}>
					<BlockComposicao>
						<h2 id="composicao">Composição do índice</h2>
						<Tabela>
							<TabelaCalendario
								variant={'dark-blue'}
								reference="com"
								headers={['Ticker', 'Ativo', 'Quantidade Teórica', 'Peso (%)']}
								data={composicaoData}
								buttonText="Composição completa"
								hideFilterCalendar={true}
								onDownloadClick={() =>
									handleDownloadClick('DownloadComposicaoIndice')
								}
								rowsPerPageInit={7}
								hidePagination={false}
								textColorPagination="white"
								backgroudColorPagination="#418FDE"
							/>
						</Tabela>
					</BlockComposicao>
				</ContentComposicao>
			</BoxComposicao>
		</Container>
	);
};
